// @core/api/endpoints/document/list_document_registers.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListDocumentRegistersResponse,
} from '../../../types/document';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/document';

/**
 * List registers
 * Returns document registers for a scope.
 */
export async function ListDocumentRegisters(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListDocumentRegistersResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/document-registers`;
  const requestOptions = options;
  return client.get<ListDocumentRegistersResponse>(requestPath, { ...requestOptions, params });
}
